import axios from "axios";
const baseUrl = "/api/v1";

// This file specifically will be for profile page
export const profile = {
  get: () => axios.get(`${baseUrl}/users/me`), // get current user
  put: (id, payload) => axios.put(`${baseUrl}/users/${id}`, payload), // update profile / user data
};
